import { z } from 'zod';

export type SignInRequest = z.infer<typeof $SignInRequest>;
export const $SignInRequest = z.object({
  email: z.string(),
  password: z.string(),
});

export type TokensData = z.infer<typeof $TokensData>;
export const $TokensData = z.object({
  tokenType: z.string(),
  expiresIn: z.number(),
  accessToken: z.string(),
  refreshToken: z.string(),
});

export type User = z.infer<typeof $User>;
export const $User = z.object({
  id: z.number().int(),
  email: z.string(),
  auctionAccess: z.boolean(),
  instructionShowed: z.boolean(),
  createdAt: z.string(),
  profile: z.object({
    phone: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    patronymic: z.string().optional(),
    avatar: z
      .object({
        id: z.number().int(),
        name: z.string(),
        disk: z.string(),
        extension: z.string(),
        size: z.number().int(),
        absolutePath: z.string(),
        type: z.string(),
        isActive: z.boolean(),
        createdAt: z.string(),
      })
      .optional(),
  }),
  role: z.object({
    name: z.string(),
    displayName: z.string(),
  }),
  company: z.object({
    createdAt: z.string(),
    description: z.string().nullable(),
    id: z.number().int(),
    isActive: z.boolean(),
    name: z.string(),
    nif: z.string(),
    regionId: z.number().int().nullable(),
    type: z.string(),
    updatedAt: z.string(),
  }),
});

export type SignInResponse = z.infer<typeof $SignInResponse>;
export const $SignInResponse = z.object({
  data: $TokensData,
  meta: z.object({
    user: $User,
  }),
});

export type RecoveryPasswordRequest = z.infer<typeof $RecoveryPassword>;
export const $RecoveryPassword = z.object({
  email: z.string(),
});

export type RecoveryPasswordResponse = z.infer<
  typeof $RecoveryPasswordResponse
>;
export const $RecoveryPasswordResponse = z.object({
  data: z.null(),
});

export type ResetPasswordRequest = z.infer<typeof $ResetPasswordRequest>;
export const $ResetPasswordRequest = z.object({
  token: z.string(),
  password: z.string(),
  passwordConfirmation: z.string(),
});

export type ResetPasswordResponse = z.infer<typeof $ResetPasswordResponse>;
export const $ResetPasswordResponse = z.object({
  data: z.null(),
});

export type RegisterRequest = z.infer<typeof $RegisterRequest>;
export const $RegisterRequest = z.object({
  email: z.string(),
  password: z.string(),
  password_confirmation: z.string(),
  profile: z.object({
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
  }),
  company: z.object({
    name: z.string().optional(),
    type: z.string().nullable(),
    nif: z.string(),
    regionId: z.number().int().nullable(),
    description: z.string(),
    isActive: z.boolean(),
  }),
});

export type RegisterResponse = z.infer<typeof $RegisterResponse>;
export const $RegisterResponse = z.string();

export type VerifyEmailRequest = z.infer<typeof $VerifyEmailRequest>;
export const $VerifyEmailRequest = z.object({
  token: z.string(),
});

export type VerifyEmailResponse = z.infer<typeof $VerifyEmailResponse>;
export const $VerifyEmailResponse = z.object({
  data: z.object({
    tokenType: z.string(),
    expiresIn: z.number(),
    accessToken: z.string(),
    refreshToken: z.string(),
  }),
  meta: z.object({
    user: z.object({
      id: z.number().int(),
      email: z.string(),
      createdAt: z.string(),
      updatedAt: z.string(),
      role: z.string().nullable(),
      profile: z.object({
        firstName: z.string(),
        lastName: z.string(),
        phone: z.string().nullable(),
      }),
    }),
  }),
});
